<div class="onboarding-container"
     (touchstart)="onTouchStart($event)"
     (touchend)="onTouchEnd($event)">

  <div class="slider-viewport">
    <div class="slides-wrapper" [style.transform]="getTransform()" [style.transition]="transition">
      <div class="slide" *ngFor="let slide of slides">
        <img [src]="slide.image" class="slide-img" alt="Slide image" />
        <h2 class="slide-title">{{ slide.title }}</h2>
        <p class="slide-text">{{ slide.text }}</p>
      </div>
    </div>

    <div class="dots">
        <span class="dot" *ngFor="let slide of slides; let idx = index" [class.active]="idx === currentSlide"></span>
      </div>
    
      <div class="button-row">
        <button *ngIf="currentSlide > 0" class="nav-button back" (click)="prevSlide()">Anterior</button>
        <button class="nav-button" (click)="nextSlide()">
          {{ currentSlide < slides.length - 1 ? 'Siguiente' : 'Empezar' }}
        </button>
      </div>
  </div>

  
</div>
